module.exports = __webpack_public_path__ + "img/app_icon.b5a0aa89.png";